import { mdiEmoticonHappyOutline, mdiEmoticonSadOutline } from '@mdi/js';
import Icon from '@mdi/react';

export const tableColumns = {
  Dt: 'Date',
  DayName: 'Day',
  TimeIn: 'Office Login',
  TimeOut: 'Office Logout',
  Hrs: 'Hrs',
  M_TimeIn: 'Manual In',
  M_TimeOut: 'Manual Out',
  M_Hrs: 'Hrs',
  Status: 'Status',
};

export const timesheetLegend = {
  Approved: { backgroundColor: '#2E90FA', text: 'Approved' },
  Rejected: { backgroundColor: '#F04438', text: 'Rejected' },
  'Waiting for Approval': {
    backgroundColor: '#EF6820',
    text: 'Waiting for Approval',
  },
  Query: { backgroundColor: '#667085', text: 'Query' },
  '': { backgroundColor: '#9E9E9E', text: 'No Data' },
};

export const dataConfig = [
  {
    key: 'EventTyp',
    label: 'Type',
    type: 'text',
  },
  {
    key: 'Date',
    label: 'Date',
    type: 'text',
    render: item => {
      const date = new Date(item.Date);
      return date.toLocaleDateString('en-GB', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
      });
    },
  },
  {
    key: 'Subject',
    label: 'Subject',
    type: 'text',
  },
  {
    key: 'StartTime',
    label: 'Start Time',
    type: 'text',
  },
  {
    key: 'EndTime',
    label: 'End Time',
    type: 'text',
  },
];

export const renderTimesheetStatusLegend = status => {
  switch (status) {
    case 'Late/Early':
      return (
        <div className="d-flex align-items-center justify-content-center">
          <Icon size={1} path={mdiEmoticonSadOutline} color="#F16A6A" />
        </div>
      );
    case 'Holiday':
    case 'Today':
      return null;
    default:
      return (
        <div className="d-flex align-items-center justify-content-center">
          <Icon size={1} path={mdiEmoticonHappyOutline} color="#6AB91C" />
        </div>
      );
  }
};

export const MONTHS = [
  { label: 'Jan', value: 0 },
  { label: 'Feb', value: 1 },
  { label: 'Mar', value: 2 },
  { label: 'Apr', value: 3 },
  { label: 'May', value: 4 },
  { label: 'Jun', value: 5 },
  { label: 'Jul', value: 6 },
  { label: 'Aug', value: 7 },
  { label: 'Sep', value: 8 },
  { label: 'Oct', value: 9 },
  { label: 'Nov', value: 10 },
  { label: 'Dec', value: 11 },
];
